module.exports = __webpack_public_path__ + "img/project.4d34c8d5.png";